/*
 * TD lazy Swiper loader + <swiper-slider> custom element.
 *
 * This file is injected by `snippets/td-swiper-assets.liquid` with the Swiper
 * vendor URLs on `data-swiper-script` / `data-swiper-css`. It injects the vendor
 * bundle and only defines <swiper-slider> once `window.Swiper` is available, so
 * initialisation never races the vendor script. Pages that don't render the
 * snippet never load this file, and therefore never load Swiper.
 */
(function () {
  if (window.__tdSwiperLoaderInit) return;
  window.__tdSwiperLoaderInit = true;

  function loadSwiperAssets() {
    const loader = document.querySelector("[data-swiper-script]");
    if (!loader) return;

    const swiperCSSURL = loader.dataset.swiperCss;
    if (swiperCSSURL && !document.querySelector(`link[href="${swiperCSSURL}"]`)) {
      const swiperCSS = document.createElement("link");
      swiperCSS.rel = "stylesheet";
      swiperCSS.href = swiperCSSURL;
      document.head.prepend(swiperCSS);
    }

    if (window.Swiper) {
      defineSwiperSlider();
      return;
    }

    const swiperScriptURL = loader.dataset.swiperScript;
    if (!swiperScriptURL) return;

    const existingScript = document.querySelector(`script[src="${swiperScriptURL}"]`);
    if (existingScript) {
      if (window.Swiper) {
        defineSwiperSlider();
      } else {
        existingScript.addEventListener("load", defineSwiperSlider, { once: true });
      }
      return;
    }

    const swiperScript = document.createElement("script");
    swiperScript.src = swiperScriptURL;
    swiperScript.async = true;
    swiperScript.onload = defineSwiperSlider;
    document.head.appendChild(swiperScript);
  }

  function boot() {
    if (
      (window.Shopify && window.Shopify.designMode) ||
      document.querySelector("swiper-slider") ||
      document.querySelector("[data-swiper-script]")
    ) {
      loadSwiperAssets();
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  function defineSwiperSlider() {
    if (customElements.get("swiper-slider")) return;

    class SwiperSlider extends HTMLElement {
      constructor() {
        super();
        this.activeIndex = 0;
        this.initialized = false;
        this.listenerController = null;
      }

      connectedCallback() {
        this.listenerController = new AbortController();
        const signal = this.listenerController.signal;

        this.slideContainer = this.querySelector("[data-swiper]:not([data-swiper-thumbs])");
        this.slides = this.querySelectorAll("[data-swiper-slide]");
        this.sliderOptions = this.applyDefaultOptions(this.getSliderOptions(this.dataset.swiperOptions));
        if (this.dataset.swiperThumbs) {
          this.thumbnails = this.querySelector("[data-swiper-thumbs]");
        }
        if (this.dataset.customEvent) {
          this.attachCustomListeners(this.dataset.customEvent, signal);
        }
        if (this.slideContainer && this.slides.length > 0) {
          document.addEventListener("shopify:section:load", this.initializeSwiper.bind(this), { signal });
          window.addEventListener("resize", this.handleResize.bind(this), { signal });
          this.addEventListener("go-to-slide", this.goToSlide.bind(this), { signal });
          this.addEventListener("update-slides", this.updateSlides.bind(this), { signal });
          this.initializeSwiper();
        } else {
          console.warn("SwiperSlider - Slider or Slides Not Found");
        }
      }

      disconnectedCallback() {
        if (this.listenerController) {
          this.listenerController.abort();
        }
      }

      attachCustomListeners(customEvent, signal) {
        switch (customEvent) {
          case "swiper_event":
            document.addEventListener("swiper_event", this.updateSlides.bind(this), { signal });
            break;
        }
      }

      updateSlides(evt) {
        this.slider.appendSlide(evt.detail.slides);
        this.goToSlide(evt);
        if (this.slider.thumbs) {
          this.slider.thumbs.swiper.update();
        }
        this.slider.update();
      }

      goToSlide(evt) {
        let index = evt.detail.index;
        if (!index && evt.detail.position) {
          const elm = this.querySelector("[data-position='" + evt.detail.position + "']");
          index = [...elm.parentNode.children].indexOf(elm);
        }
        if (index !== 0 && !index) return;
        this.slider.slideTo(index);
      }

      applyDefaultOptions(options) {
        if (options.loop === undefined) {
          options.loop = true;
        }
        options.speed = 400;
        return options;
      }

      getSliderOptions(data) {
        try {
          return JSON.parse(data);
        } catch (err) {
          console.log(err);
          return {};
        }
      }

      initializeSwiper() {
        if (window.Swiper && !this.initialized) {
          this.initialized = true;
          if (this.thumbnails) {
            this.setThumbnails();
          }
          this.slider = new Swiper(this.slideContainer, this.sliderOptions);
          this.initializeSliderEventListeners();
          this.dispatchEvent(new CustomEvent("swiper:ready", {
            detail: {
              swiper: this.slider
            }
          }));
        } else if (!window.Swiper) {
          console.warn("SwiperSlider - Swiper.js not found");
        }
      }

      handleResize() {
        if (this.slider) {
          setTimeout(() => {
            this.slider.updateSize();
          }, 300);
        }
      }

      setThumbnails() {
        const thumbsSlideContainer = this.thumbnails;
        const thumbOptions = this.getSliderOptions(this.thumbnails.dataset.swiperOptions);
        const thumbnailsSlider = new Swiper(thumbsSlideContainer, thumbOptions);
        this.sliderOptions.thumbs = { swiper: thumbnailsSlider };
        this.sliderOptions.on = {
          slideChange: function () {
            const activeIndex = this.activeIndex;
            this.thumbs.swiper.slideTo(activeIndex - 1);
          }
        };
      }

      initializeSliderEventListeners() {}
    }

    customElements.define("swiper-slider", SwiperSlider);
  }
})();
